<script setup lang="ts">
import {
	PinInputInput,
	type PinInputInputProps,
	useForwardProps,
} from 'radix-vue';
import { type HTMLAttributes, computed } from 'vue';
import { pinInputVariants } from '.';

interface Props extends PinInputInputProps {
	class?: HTMLAttributes['class'];
	hasError?: boolean;
}

const props = defineProps<Props>();

const delegatedProps = computed(() => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { class: _class, hasError: _hasError, ...delegated } = props;
	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<PinInputInput
		v-bind="forwardedProps"
		:class="[pinInputVariants({ hasError }), props.class]"
	/>
</template>
